<template>
  <div>
    <validation-observer ref="fatorRiscoForm">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.has"
              name="has"
              :disabled="disableForm"
            >
              Has
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.diabetes"
              name="diabetes"
              :disabled="disableForm"
            >
              Diabetes
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.tabagismo"
              name="tabagismo"
              :disabled="disableForm"
            >
              Tabagismo
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.sedentarismo"
              name="sedentarismo"
              :disabled="disableForm"
            >
              Sedentarismo
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.disfuncaoTireoidiana"
              name="disfuncao-tireoidiana"
              :disabled="disableForm"
            >
              Disfunção Tireoidiana
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.febreReumaticaPrevia"
              name="febre-reumatica-previa"
              :disabled="disableForm"
            >
              Febre Reumática Prévia
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.dpoc"
              name="dpoc"
              :disabled="disableForm"
            >
              DPOC
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.trombofilias"
              name="trombofilias"
              :disabled="disableForm"
            >
              Trombofilias
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.hereditariedadeDac"
              name="hereditariedade-dac"
              :disabled="disableForm"
            >
              Hereditariedade DAC
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.obesidade"
              name="obesidade"
              :disabled="disableForm"
            >
              Obesidade
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="fatorRisco.nefropatias"
              name="nefropatias"
              :disabled="disableForm"
            >
              Nefropatias
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" lg="8">
            <b-form-checkbox
              v-model="fatorRisco.outros"
              name="outros"
              :disabled="disableForm"
            >
              Outros
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" class="mt-2">
            <b-form-group label="Descrição" label-for="v-outros-fator-risco">
              <b-form-textarea
                v-model="fatorRisco.outrosDescricao"
                :disabled="disableForm || !fatorRisco.outros"
                rows="3"
                max-rows="6"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <ButtonsFormVue
            label-edit="Editar Fator de Risco"
            label-save="Salvar Fator de Risco"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import {
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BForm,
  BRow,
  BCol,
} from "bootstrap-vue";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
export default {
  components: {
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BForm,
    BRow,
    BCol,
    ValidationObserver,
    ButtonsFormVue,
  },
  mixins: [mixinsGlobal],
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      fatorRisco: {},
    };
  },
  watch: {
    parecer: {
      handler(newVal) {
        if (newVal && newVal.fatorRisco) {
          this.setFatorDeRiscoData(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Deseja realmente sair da atualização do Fator de Risco?",
          {
            title: "Confirmação",
            size: "sm",
            okVariant: "primary",
            okTitle: "Sim",
            cancelTitle: "Não",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setFatorDeRiscoData(this.parecer);
      this.$refs.fatorRiscoForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    setFatorDeRiscoData(data) {
      if (data && data.fatorRisco) {
        this.fatorRisco = {
          id: data.id,
          ...this.fatorRisco,
          ...data.fatorRisco,
        };
      }
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.fatorRiscoForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch(
                "parecerCardiologicoModule/salvarFatorDeRisco",
                this.fatorRisco
              )
              .then((response) => {
                this.fatorRisco = {
                  id: response.data.id,
                  ...response.data.fatorRisco,
                };
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Fator de Risco Editado com sucesso!"
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
